/** Longest default duration a template may set: 7 days, the most the hour picker offers. */
export const CAL_EVENT_TEMPLATE_MAX_DURATION_MINUTES = 7 * 24 * 60;
//# sourceMappingURL=cal-event-template-max-duration-minutes.js.map